/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  ISingletonFactory,
  ISingletonFactoryInterface,
} from "../../../contracts/WriteOnce.sol/ISingletonFactory";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes",
        name: "initCode",
        type: "bytes",
      },
      {
        internalType: "bytes32",
        name: "salt",
        type: "bytes32",
      },
    ],
    name: "deploy",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

export class ISingletonFactory__factory {
  static readonly abi = _abi;
  static createInterface(): ISingletonFactoryInterface {
    return new Interface(_abi) as ISingletonFactoryInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): ISingletonFactory {
    return new Contract(address, _abi, runner) as unknown as ISingletonFactory;
  }
}
